var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBonusBuy = function SvgBonusBuy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 23,
    stroke: "#fff",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M29.992 16h-3v2.568c-1.04.114-2.044.377-2.918.832-1.257.652-2.287 1.732-2.62 3.285-.398 1.852.284 3.575 1.59 4.772 1.017.932 2.39 1.54 3.948 1.753v5.182c-2.325-.396-4.01-1.788-4.552-2.547L20 33.59c1.003 1.403 3.56 3.419 6.992 3.834V40h3v-2.602c1.596-.198 2.904-.682 3.9-1.43 1.371-1.03 2.028-2.477 2.028-3.968 0-1.645-.983-3.1-2.32-4.08-.977-.718-2.209-1.242-3.608-1.48V21.73c1.39.385 2.629 1.244 3.73 2.528L36 22.305c-1.607-1.872-3.615-3.211-6.007-3.65zm-3 5.593c-.606.094-1.125.256-1.535.469-.644.334-.964.755-1.07 1.253-.149.692.069 1.366.685 1.93.436.4 1.084.745 1.92.922zm3 7.91v4.865c.994-.168 1.666-.474 2.097-.798.608-.457.83-1.01.83-1.57 0-.407-.266-1.055-1.094-1.663-.473-.346-1.09-.646-1.833-.834",
    className: "bonusBuy_svg__fill",
    clipRule: "evenodd"
  })));
};
export default SvgBonusBuy;